import type { SharedUrl } from '@salescore/client-api'
import { CORE_CONSTANT, viewConfigFilterNodeSchema, type ViewConfigSheet } from '@salescore/core'
import { stableStringify } from '@salescore/features'
import { Match, Order } from 'effect'
import { z } from 'zod'

export function detectSharedUrlSettings(config: ViewConfigSheet, sharedUrl: SharedUrl | undefined) {
  try {
    const sharedUrlFilterTree = z
      .object({
        filterTree: viewConfigFilterNodeSchema,
      })
      .parse(sharedUrl?.parameter)
    return stableStringify(config.filterTree) === stableStringify(sharedUrlFilterTree.filterTree)
  } catch {
    return false
  }
}

/**「追加したいオブジェクト」の並び順 */
export const PropertySelectorTableForContextMenuOptionOrder = Order.mapInput(Order.Number, (model: { name: string }) =>
  ObjectOrder(model.name),
)

/** KPIの「集計のベースとなるオブジェクト」の並び順 */
export const KpiFormRootNodeFormItemOptionOrder = Order.mapInput(Order.Number, (model: { name: string }) =>
  ObjectOrder(model.name),
)

/**
 * シート・KPIで選択するオブジェクトの並び順を定義
 * - 以下の順番で表示する
 *  1. salesforce
 *  2. hubspot
 *  3. kintone
 *  4. google_sheets
 *  5. カスタム
 *  6. スナップショット≒④ SALESCOREカスタム
 *  7. 上記条件に当てはまらないその他のオブジェクト
 */
export const ObjectOrder = (name: string): number => {
  // "_"区切りで判定できないため、"google_sheets_"は.startsWith()で判定する
  if (name.startsWith('google_sheets_')) return 3
  const [prefix] = name.split('_')
  return Match.value(prefix).pipe(
    Match.when(
      (p) => p === 'salesforce',
      () => 0,
    ),
    Match.when(
      (p) => p === 'hubspot',
      () => 1,
    ),
    Match.when(
      (p) => p === 'kintone',
      () => 2,
    ),
    // "3"は前述の"google_sheets_"
    Match.when(
      (p) => p === 'custom',
      () => 4,
    ),
    Match.when(
      (p) => p === 'salescore' || p === CORE_CONSTANT.SNAPSHOT_MODEL_PREFIX,
      () => 5,
    ),
    Match.orElse(() => 6),
  )
}
